import logger from "@/utilities/logger";

const ALLOWED_NS = ['local', 'dev', 'prod'];
const rawNs = process.env.VUE_APP_COOKIE_NAMESPACE;
if (!ALLOWED_NS.includes(rawNs)) {
    logger.error(`[cookie-ns] invalid VUE_APP_COOKIE_NAMESPACE="${rawNs}"`);
    throw new Error(`invalid VUE_APP_COOKIE_NAMESPACE="${rawNs}"`);
}
const host = typeof window !== 'undefined' ? window.location.hostname : '';
const expected =
    host.startsWith('local.') ? 'local' :
    host.startsWith('dev.')   ? 'dev'   :
    host.endsWith('tech-square.co.kr') ? 'prod' : null;
if (expected && expected !== rawNs) {
    logger.warn(`[cookie-ns] build=${rawNs} host=${host} expected=${expected}`);
}

export const COOKIE_NS = rawNs;
export const AUTH_COOKIE_NAMES = {
    access:    `accessToken_${COOKIE_NS}`,
    refresh:   `refreshToken_${COOKIE_NS}`,
    indicator: `tsq_authed_${COOKIE_NS}`,
};

export class Cookie {
    setCookie(cName, cValue, expDays) {
        const expires = 'expires=' + expDays;
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        const secure = isLocalhost ? '' : '; Secure';
        document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/; SameSite=Lax' + secure;
    }

    getCookie(cName) {
        const name = cName + '=';
        const cDecoded = decodeURIComponent(document.cookie); //to be careful
        const cArr = cDecoded.split('; ');
        let res;
        cArr.forEach((val) => {
            if (val.indexOf(name) === 0) res = val.substring(name.length);
        });
        return res;
    }

    deleteCookie(name) {
        this.setCookie(name, '', 'Thu, 01 Jan 1970 00:00:01 GMT;');
    }
}
